jQuery(document).ready(function(){
    jQuery('input, select').each(function(){
        let input = jQuery(this);
        checkInput(input);
        input.keyup(function(){checkInput(input)});
        input.focusout(function(){checkInput(input)})
        input.focusin(function(){checkInput(input)})
    })
})

function checkInput(input){
    if(input.val().length || input.is(':focus')) input.parent().parent().addClass('active');
    else input.parent().parent().removeClass('active');
}
